import { render, staticRenderFns } from "./NotificationsContainer.vue?vue&type=template&id=2e1560f3"
import script from "./NotificationsContainer.vue?vue&type=script&lang=ts"
export * from "./NotificationsContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports